import styled from 'styled-components'
import { Theme } from 'styles/Themes'
import responsiveSize from 'helper/responsiveSize'

interface IInputProps {
  empty?: boolean
  error?: string
  secondary?: boolean
}

export const Span = styled.span`
  position: absolute;
  left: 11px;
  top: -13px;

  color: ${(props: IInputProps) =>
    props.secondary ? Theme.pallete.PRIMARY4 : Theme.pallete.QUATERNARY};
  font-family: ${Theme.fontFamily.SECONDARY};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;

  height: 20;

  padding: 2px 10px;
  border-radius: 10px;

  background: ${(props: IInputProps) =>
    props.secondary ? Theme.pallete.SECONDARY : Theme.pallete.PRIMARY};

  opacity: ${(props: IInputProps) => (props.empty ? '0' : '1')};

  @media only screen and (min-width: 1441px) {
    font-size: 13px;
    padding: 2px 14px;
  }
`

export const Input = styled.input`
  background: ${(props: IInputProps) =>
    props.secondary ? Theme.pallete.SECONDARY : Theme.pallete.PRIMARY};

  font-family: ${Theme.fontFamily.SECONDARY};

  color: ${(props: IInputProps) =>
    props.secondary ? Theme.pallete.PRIMARY4 : Theme.pallete.QUATERNARY};

  border-radius: 5px;

  width: 252px;
  height: 40px;

  font-size: 12px;
  font-style: normal;
  font-weight: 400;

  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

  -webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px red inset !important;
  }

  -webkit-text-fill-color: ${(props: IInputProps) =>
    props.secondary
      ? Theme.pallete.PRIMARY4
      : Theme.pallete.QUATERNARY} !important;

  padding: 13px;

  border: ${(props: IInputProps) => {
    if (props.error) return `1px solid ${Theme.pallete.SENARY}`
    if (props.secondary) return `1px solid #cccccc`
    return `1px solid ${Theme.pallete.QUATERNARY}`
  }};

  &:hover {
    background: ${(props: IInputProps) => {
      if (props.secondary) return `${Theme.pallete.SECONDARY3}`
      return `${Theme.pallete.PRIMARY4}`
    }};
    color: ${Theme.pallete.SECONDARY3};
  }

  &::placeholder {
    color: #cccccc;
  }

  &:focus {
    &::placeholder {
      color: transparent;
      opacity: 0;
    }
  }

  &:disabled {
    &::placeholder {
      color: #fff;
    }
    background: lightGray;
    border: 0;
  }

  &:placeholder-shown {
    text-overflow: ellipsis;
  }

  @media only screen and (min-width: 1441px) {
    height: 45px;
    width: 284px;
    font-size: 13px;
    padding: 14px;
  }
`

export const Error = styled.p`
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  color: ${Theme.pallete.SENARY};
  margin-top: 10px;
`

export const InputError = styled.div`
  font-family: ${Theme.fontFamily.SECONDARY};
  position: absolute;
  bottom: -3px;
  transform: translateY(100%);
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: start;
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  color: ${Theme.pallete.SENARY};
`
